import { Flex, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { BsFillPlayCircleFill } from "react-icons/bs";

export default function Banner() {
  return (
    <Flex
      bgImage={{
        base: "url('/images/marketplace/marketplace-mobile-banner.png')",
        md: "url('/images/marketplace/marketplace-banner.png')",
      }}
      height={{ base: "480px", md: "400px", xl: "400px" }}
      w="full"
      bgSize={"contain"}
      bgRepeat="no-repeat"
      justifyContent={"center"}
      alignItems="center"
      flexDirection="column"
      color="white"
      gap={{ base: 2, lg: 4 }}
      backgroundPosition="center"
    >
      <Stack alignItems="center">
        <Heading
          fontWeight={400}
          color="white"
          fontSize={{ base: "24px", xl: "40px" }}
          textAlign={"center"}
        >
          Explore Gig Marketplace
        </Heading>
        <Text
          color="brand.100"
          fontSize={{ base: "13px", xl: "17px" }}
          textAlign={"center"}
          fontWeight={"semibold"}
        >
          Unreal works made by real Decolance freelancers
        </Text>
      </Stack>

      <Flex
        gap={2}
        color="white"
        alignItems="center"
        fontSize={{ base: "22px", xl: "44px" }}
      >
        <BsFillPlayCircleFill />
        <Text fontSize={{ base: "10px", xl: "17px" }}>How Decolance works</Text>
      </Flex>
    </Flex>
  );
}
